module.exports = __webpack_public_path__ + "img/bbb2.9be76d2b.gif";